import React, { useEffect } from "react";
import { CommonButton, CommonTextCustomSize } from "../AtomCommonComponents";
import { CommonModal } from "../MoleculesCommonComponent";
import TextFormatUtils from "../../../utils/TextFormatUtils";
import { AddEditAddressModalType, AddEditDataModalType } from "../../../types/types";

interface AddressSuggestionMarketModalProps {
  isAddressSuggestionMarketModal: boolean;
  onCloseAddEditAddressModal: () => void;
  setEditDataModal?: React.Dispatch<React.SetStateAction< AddEditAddressModalType>> | React.Dispatch<React.SetStateAction<AddEditDataModalType>>;
  setAddDataModal: React.Dispatch<React.SetStateAction< AddEditAddressModalType>> | React.Dispatch<React.SetStateAction<AddEditDataModalType>>;
  addressSuggestionsData: any;
  mode: string;
}

const AddressSuggestionMarketModal: React.FC<AddressSuggestionMarketModalProps> = (props) => {
  const { isAddressSuggestionMarketModal, onCloseAddEditAddressModal, addressSuggestionsData, setAddDataModal, setEditDataModal, mode } = props;

  useEffect(() => {
    const initialize = () => {};
    initialize();
  }, []);

  const onClickSuggestedButton = (index: number) => {
    const selectedAddress = addressSuggestionsData[index];
    if (mode === "edit") {
      setEditDataModal && setEditDataModal((prevState:any) => ({
        ...prevState,
        address_1: selectedAddress.address_1,
        address_2: selectedAddress.address_2,
        city: selectedAddress.city,
        country: selectedAddress.country,
        zip_code: selectedAddress.zip_code,
        state: selectedAddress.state,
        geolocation: [selectedAddress.location.lat, selectedAddress.location.lng],
      }));
      setTimeout(() => {
        onCloseAddEditAddressModal();
      }, 1000);
    } else {
      setAddDataModal((prevState:any) => ({
        ...prevState,
        address_1: selectedAddress.address_1,
        address_2: selectedAddress.address_2,
        city: selectedAddress.city,
        country: selectedAddress.country,
        zip_code: selectedAddress.zip_code,
        state: selectedAddress.state,
        geolocation: [selectedAddress.location.lat, selectedAddress.location.lng],
      }));
      setTimeout(() => {
        onCloseAddEditAddressModal();
      }, 1000);
    }
  };

  return (
    <>
      <CommonModal maskClosable={false} title={"Address Suggestion"} visible={isAddressSuggestionMarketModal} footer={null} closable={false}>
        <div>
          <CommonTextCustomSize margin={"-12px 0px 20px 0px"}fontSize="14px" color="primary">Please select the address in the list below based on the information you provided.</CommonTextCustomSize>
          {addressSuggestionsData?.map((address: any, index: number) => (
            <CommonButton
              width="100%"
              color="white"
              background="primary"
              key={address.id}
              marginBottom="5px"
              onClick={() => onClickSuggestedButton(index)}
            >
              {TextFormatUtils.ellipsis(
                [address.address_1, address.city, address.state, address.zip_code, address.country].filter(Boolean).join(", "),
                45
              )}
            </CommonButton>
          ))}
        </div>
      </CommonModal>
    </>
  );
};

export default AddressSuggestionMarketModal;
